import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import Select from "react-select";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./Gigs.css";
import Input from "../../components/Input";
import Overlay from "../../components/Overlay";
import { Modal } from "../../components/Modal";
import { bottom } from "@popperjs/core";
import BlockToggle from "../../components/Toglebutton/Togle";
import { RxCross2 } from "react-icons/rx";
import {
    extractDate,
    extractOnlyDate,
    subadminAccessChange,
} from "../../utils/functions";
import * as XLSX from 'sheetjs-style';
import { saveAs } from "file-saver";
import { TiInfoLarge } from "react-icons/ti";

// Mui & material UI
import Stack from "@mui/material/Stack";
import SearchBar from "material-ui-search-bar";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Popover, Box } from "@mui/material";
import PaginationItem from "@mui/material/PaginationItem";


import {

    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,

} from "@material-ui/core";

// icons
import { PiExportBold } from "react-icons/pi";
import { HiOutlineBars3BottomLeft } from "react-icons/hi2";
import { AiOutlineDownload } from "react-icons/ai";
import { FaEyeSlash } from "react-icons/fa6";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { BsEyeFill, } from "react-icons/bs";
import ReactReadMoreReadLess from "react-read-more-read-less";
import {
    FaUser,
} from "react-icons/fa";
import { GrCircleInformation } from "react-icons/gr";
import Stars from 'react-stars';


import EyeIcon from "../../assets/images/eye.png";
import UserIcon from "../../assets/images/human.png";
import Star from "../../assets/images/star.png";
import vector from "../../assets/images/Vector.png";

import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    SearchFilterContainer,
    DashHeading,
    Button,
    ProfileDetailForm,
} from "./GigsManagementElement";
import YearInput from "../../components/YearInput";
import NoResults from "../../components/NoResult";
import Loading from "../../components/Loading";

const useStyles = makeStyles((theme) => ({
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px', // adds vertical spacing between rows
    },
    tableMainContainer: {
        maxHeight: "65vh",
        overflowX: "auto",
        overflowY: "auto",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",

        // border: "1px solid rgba(17, 153, 38, 0.20)",

        // Optional scrollbar customization
        '&::-webkit-scrollbar': {
            height: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#5088FB',     // Scrollbar color
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
        },
    },
    tableHeadingRow: {
        position: "sticky", // Make header sticky
        top: 0, // Stick to the top
        zIndex: 1, // Ensure it appears above other rows
        background: "#FFFFFF", // Header background color
        // border: "1px solid rgba(17, 153, 38, 0.20)",

    },
    tableBodyRow: {
        background: "#FFFFFF",
        border: "1px solid rgba(17, 153, 38, 0.20)",

        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    tableHeadingCell: {
        // padding: "0.5rem 1rem !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#1C2D28",
        fontWeight: "500",
        // border: "1px solid #D9E3D9",
        whiteSpace: "nowrap",
        background: "#FFFFFF",
        border: "none",

    },
    textMiddle: {
        padding: "0.3rem 1rem !important",
        verticalAlign: "middle !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#484848",
        fontFamily: "Roboto",
        fontWeight: "400",
        background: "#FFFFFF",
        border: "none",

    },
    tablePaginationStyle: {
        borderTop: "1px solid #0000001a",
        borderRadius: "0rem 0rem 0.4rem 0.4rem",
        overflowY: "hidden",
    },
    paginationContainer: {
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));

const GigsManagement = ({ setUsers, userData, user }) => {

    const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

    const gigsManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "Gigs Management"
    )?.permissions || {};

    const canView = !!gigsManagementPermissions.view;
    const canAdd = !!gigsManagementPermissions.add;
    const canEdit = !!gigsManagementPermissions.edit;
    const canDelete = !!gigsManagementPermissions.delete;
    const canBlockUnblock = !!gigsManagementPermissions.blockUnblock;
    const canDownload = !!gigsManagementPermissions.download;


    const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "User Management"
    )?.permissions || {};

    const isSubAdmin = adminData?.userType === "subAdmin";

    // Check if view permissions in User Management are false
    const hasNoUserManagementPermissions = userManagementPermissions &&
        !userManagementPermissions.view



    //  {!(!canBlockUnblock && adminData?.userType === "subAdmin") && (


    const location = useLocation();
    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isVisible, setIsVisible] = useState(true); // Initial state
    const [excelGigData, setExcelGigData] = useState([]);

    const [userInfo, setUserInfo] = useState([])
    const [statusHistryData, setStatusHistryData] = useState([])

    const [description, setDescription] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [userDetails, setUserDetails] = useState();

    const [hostDescription, setHostDescription] = useState(false);
    const [hostSelectedUser, setHostSelectedUser] = useState(null);

    const [tabSwitch, setTabSwitch] = useState(
        localStorage.getItem("filterTypeBooking") || "1"

    ); // Default to ongoing
    console.log("filterTypeBooking", localStorage.getItem("filterTypeBooking"))

    const handleServiceTypeChange = (type) => {
        setTabSwitch(type);
        setIsLoading(true);
        localStorage.setItem("filterTypeBooking", type); // Save the active tab to localStorage
    };

    // For Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocs, setTotalDocs] = useState(0);



    const handleChangePage = (event, newPage) => {
        handleCancel(); // your custom logic
        setPage(newPage); // this will trigger useEffect
    };

    // Filter Start
    const [startDate, setStartDate] = useState(null);
    const [completedDate, setcompletedDate] = useState(null)

    const [filterDates, setFilterDates] = useState({
        startDate: "",
    });

    const [filterCompletedDates, setFilterCompletedDates] = useState({
        completedDate: "",
    });




    const [allZip, setAllZip] = useState([]);
    const [selectedTypeOption, setSelectedTypeOption] = useState(null); // For service type filtering
    const [selectedPayOption, setSelectedPayOption] = useState(null);
    const [selectedZipOption, setSelectedZipOption] = useState(null);
    const [allCategoryData, setAllCategoryData] = useState(); // For store all category
    const [selectedGigStatusOption, setSelectedGigStatusOption] = useState(null); // For Booking status filtering
    const [selectedGigTypeOption, setSelectedGigTypeOption] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElData, setAnchorElData] = useState(null);
    const [sorting, setSorting] = useState({
        sortByHostName: null,
        sortByUserType: null,
        sortByOngoingHostName: null,
    });
    const [rotations, setRotations] = useState({
        sortByHostName: 0,
        sortByUserType: 0,
        sortByOngoingHostName: 0,
    });

    // This is for particular tab switch come from dashboard
    useEffect(() => {
        if (location?.state?.dashboardTab === "ongoing" || location?.state?.dashboardTab === "hostedGigs") {
            setTabSwitch(location.state.dashboardTab);
        }
    }, [location?.state?.dashboardTab]);




    const zipCodeOptions = allZip?.map((zipCode) => ({
        label: zipCode.zip,
        value: zipCode.zip,
    })) || [];

    const GigStatusOptions = [

        { value: '1', label: 'Active' },
        { value: '0', label: 'Inactive' },
        { value: '9', label: 'Blocked' },
        { value: '4', label: 'Hired' },
        { value: '3', label: 'Expired' },
    ]

    const GigTypeOptions = [

        { value: 'onsite', label: 'On-Site' },
        { value: 'offsite', label: 'Offsite' },
    ]

    const userTypeOptions = [
        { value: "worker", label: "Worker" },
        { value: "host", label: "Host" },
    ];

    const payTypeOptions = [
        { value: "hourly", label: "Hourly" },
        { value: "contract", label: "Contract" },
    ];




    // default -> 0, bookingAccept -> 1, tripStarted -> 2, locksmithReached -> 3, serviceStarted -> 4


    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget); // Open the filter popover
    };

    const handleClick = (event) => {
        setAnchorElData(event.currentTarget); // Open the filter popover
    };

    const handleApply = () => {
        if (!startDate && !completedDate && !selectedGigStatusOption && !selectedGigTypeOption && !selectedZipOption && !selectedTypeOption && !selectedPayOption) {
            toast.warning("Please select at least one field.", {
                position: "top-right",
            });
            return;
        }
        const adjustDateTime = (date, isEndOfDay = false) => {
            if (!date) return "";

            const adjustedDate = new Date(date);

            if (isEndOfDay) {
                adjustedDate.setHours(23, 59, 59, 999); // End of the day
            } else {
                adjustedDate.setHours(0, 0, 0, 0); // Start of the day
            }

            // Manually format to avoid time zone issues
            return `${adjustedDate.getFullYear()}-${String(adjustedDate.getMonth() + 1).padStart(2, "0")}-${String(adjustedDate.getDate()).padStart(2, "0")}T${String(adjustedDate.getHours()).padStart(2, "0")}:${String(adjustedDate.getMinutes()).padStart(2, "0")}:${String(adjustedDate.getSeconds()).padStart(2, "0")}.000Z`;
        };

        const normalizedStartDate = adjustDateTime(startDate, false); // Start of the day


        setFilterDates({
            startDate: normalizedStartDate,
        });

        const normalizedStartDateData = adjustDateTime(completedDate, false); // Start of the day


        setFilterCompletedDates({
            completedDate: normalizedStartDateData,
        });




        setAnchorEl(null);
        setPage(1); // Reset to the first page
    };



    const handleCancel = () => {
        setStartDate(null);
        setcompletedDate(null)
        setFilterDates({ startDate: "" });
        setFilterCompletedDates({ completedDate: "" });

        setSelectedTypeOption(null); // Reset selected service type
        setSelectedGigTypeOption(null)
        setSelectedPayOption(null)
        setSelectedGigStatusOption(null); // Reset booking status
        setSelectedZipOption(null)
        setPage(1);
    };

    const handleClose = () => {
        setAnchorEl(null); // Only close the popover without resetting
    };

    const handleCloseData = () => {
        setAnchorElData(null); // Only close the popover without resetting
    };


    const handleCompletedDateChange = (date) => {
        setcompletedDate(date || null); // Update the start date if valid
    };

    const handleStartDateChange = (date) => {
        setStartDate(date || null); // Update the start date if valid
    };

    const open = Boolean(anchorEl);
    const id = open ? "filter-popover" : undefined;

    const openData = Boolean(anchorElData);
    const ids = openData ? "filter-popover" : undefined;


    // For Search functionality
    const [searchTerm, setSearchTerm] = useState("");

    function myDeb(call, d = 1000) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                call(...args);
            }, d);
        };
    }

    const SearchAccountManagement = myDeb((search) => {
        setSearchTerm(search);
        setPage(1); // Reset to the first page on search
    });

    const cancelSearch = () => {
        setSearchTerm("");
        setPage(1); // Reset to the first page when search is canceled
    };



    // Get Booking Management Data
    useEffect(() => {
        getAllGigs(page);
        getAllZip()
        getExcelGigsData()
            .then((res) => res.json())
            .then((data) => setExcelGigData(data))
            .catch((error) => console.error("Error fetching data:", error));

    }, [page, rowsPerPage, searchTerm, tabSwitch, filterDates]);


    const toggleSort = (field) => {
        setSorting((prev) => {
            let newSorting = {
                sortByHostName: null,
                sortByUserType: null,
                sortByOngoingHostName: null,
            };

            let newValue = prev[field] === 1 ? -1 : 1;
            newSorting[field] = newValue;

            // 👉 Rotate image toggle
            setRotations((prev) => ({
                ...prev,
                [field]: prev[field] === 0 ? 180 : 0, // toggle between 0 and 180
            }));

            // API call
            getAllGigs(1, newSorting);

            return newSorting;
        });
    };

    const getAllGigs = async (currentPage, sortingParam = sorting) => {
        setIsLoading(true);
        setTotalDocs(0);

        try {
            const { data } = await axios.post(`/private/getGigs?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`,
                {
                    startDate: filterDates.startDate || undefined,
                    completedDate: filterCompletedDates.completedDate || undefined,
                    zipCode: selectedZipOption?.length ? selectedZipOption.map((opt) => opt.value) : [],
                    status: selectedGigStatusOption?.length ? selectedGigStatusOption.map((opt) => opt.value) : [],
                    gigType: selectedGigTypeOption?.length ? selectedGigTypeOption.map((opt) => opt.value) : [],
                    type: selectedTypeOption?.length ? selectedTypeOption.map((opt) => opt.value) : [],
                    gigPayType: selectedPayOption?.length ? selectedPayOption.map((opt) => opt.value) : [],
                    pageType: String(tabSwitch), // (all->1,ongoing->2,completed->3
                    ...sortingParam,
                }
            );
            setAllCategoryData(data);
            setTotalDocs(data?.data?.totalDocs);
            setTableData(data?.data?.docs)
            // setStatusHistryData(data?.data?.docs[0]?.gigTransactionDetails)
        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else {
                console.log("error", error?.response);
            }
        } finally {
            setIsLoading(false);
        }
    };


    const getAllZip = async (currentPage) => {
        setIsLoading(true);

        try {
            const { data } = await axios.get(`https://dev.jobdashflash.com/api/user/getZipCodeList?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`);

            setAllZip(data?.zipcodeList?.docs)


        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else {
                console.log("error", error?.response);
            }
        } finally {
            setIsLoading(false);
        }
    };


    // Block unblock functionality
    const blockUnblock = async (id) => {
        try {
            const response = await axios.get(`/private/gigs/blockUnBlock/${id}`);

            toast.success(response.data.message, {
                position: "top-right",
            });
            getAllGigs(page);
        } catch (error) {

            // if (error.response?.status === 401) {
            //     toast.error(error.response.data?.errors[0]?.msg, {
            //         position: "top-right",
            //     });
            // } else 
            if (error.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                toast.error(error.response.data?.message, {
                    position: "top-right",
                });
                navigate("/");
            } else {
                toast.error("Something went wrong", {
                    position: "top-right",
                });
            }
        }
    };


    const handleDownload = () => {
        // Format keys: convert camelCase to space-separated & capitalize, handle _id
        const formatKey = (key) => {
            if (key === '_id') return 'User Id';
            return key
                .replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space before capital letters
                .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
        };


        const formatValue = (key, value) => {
            if ((key === "createdAt" || key === "startDate" || key === "endDate" || key === "completedOn") && value) {
                return new Date(value).toLocaleString("en-US", {
                    month: "2-digit",
                    day: "2-digit",
                    year: "numeric",
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true
                });
            }
            return value;
        };


        // Format data with formatted headers
        const formattedData = excelGigData.map(item => {
            const newItem = {};
            Object.entries(item).forEach(([key, value]) => {
                newItem[formatKey(key)] = formatValue(key, value);
            });
            return newItem;
        });

        // Create worksheet from formatted data
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Auto-calculate column widths
        const keys = Object.keys(formattedData[0] || {});
        const colWidths = keys.map(key => {
            const maxLength = Math.max(
                key.length,
                ...formattedData.map(row => (row[key] ? row[key].toString().length : 0))
            );
            return { wch: maxLength + 2 };
        });
        worksheet["!cols"] = colWidths;

        // Bold header row (row 0)
        keys.forEach((key, index) => {
            const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = {
                    font: { bold: true }
                };
            }
        });

        // Create workbook and append sheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Write and download
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, "table_data.xlsx");
    };


    const getExcelGigsData = async () => {

        try {
            const { data } = await axios.post(`/private/getExcelGigsData`,
                {
                    pageType: String(tabSwitch)
                });
            setExcelGigData(data?.data);


        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };


    const invoiceDownload = async (_id) => {

        try {
            const response = await axios.get(`/invoiceGigPaymentDownloadHtml/${_id}`, {
                responseType: "blob",  // Important to treat data as Blob
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `jobDash_testing.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            toast.success("Download successful!");
        } catch (error) {
            console.error("Download error:", error);
            toast.error("Something went wrong!");
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <DashboardContainer>
                <DashboardWrapper >
                    <ProfileDetailForm>
                        <DashboardHeading style={{ marginBottom: "0.7rem" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "0.8rem", }}>
                                    <div className="common-heading">Gigs Management</div>
                                    {isVisible ? (
                                        <BsEyeFill
                                            style={{
                                                fontSize: "1.2rem",
                                                color: "rgba(38, 52, 78, 1)",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setIsVisible(false)}
                                        />
                                    ) : (
                                        <FaEyeSlash
                                            style={{
                                                fontSize: "1.2rem",
                                                color: "rgba(38, 52, 78, 1)",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setIsVisible(true)}
                                        />
                                    )}
                                </div>


                                <div>
                                    {!(!canDownload && adminData?.userType === "subAdmin") && (
                                        <Button
                                            type="button"
                                            style={{ backgroundColor: "#5088FB", color: "#FFFFFF", border: "1px solid #5088FB", fontFamily: "Inter", fontSize: "14px", fontWeight: "400" }}
                                            onClick={handleDownload}
                                        >
                                            Export as xlsx <AiOutlineDownload style={{ fontSize: "1.2rem" }} />
                                        </Button>
                                    )}
                                </div>
                            </div>

                            {isVisible && (
                                <div className="user-card-container">
                                    <div className="cards">
                                        <div className="card-content">
                                            <div className="card-words">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "0.3rem",
                                                    }}
                                                >
                                                    <span className="card-heading">Hosted Gigs</span>
                                                </div>
                                                <span className="card-price">
                                                    {allCategoryData?.hostedCount ? allCategoryData?.hostedCount : 0}

                                                </span>
                                            </div>
                                            <div className="card-icon" style={{ background: "#F3F7FF" }}>
                                                <FaUser
                                                    style={{ color: " #5080FB", fontSize: "1.3rem" }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cards">
                                        <div className="card-content">
                                            <div className="card-words">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "0.3rem",
                                                    }}
                                                >
                                                    <span className="card-heading">Ongoing Gigs</span>
                                                    {/* <span className="card-title">&nbsp;</span> */}
                                                </div>
                                                <span className="card-price">
                                                    {allCategoryData?.ongoingCount
                                                        ? allCategoryData?.ongoingCount
                                                        : 0}

                                                </span>
                                            </div>
                                            <div className="card-icon" style={{ background: "#FFF3E3" }}>
                                                <img
                                                    src={UserIcon}
                                                    style={{ color: " #FDA517", fontSize: "1.3rem" }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cards">
                                        <div className="card-content">
                                            <div className="card-words">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "0.3rem",
                                                    }}
                                                >
                                                    <span className="card-heading">Completed Gigs</span>
                                                    {/* <span className="card-title">(In a week)</span> */}
                                                </div>
                                                <span className="card-price">
                                                    {allCategoryData?.completedCount
                                                        ? allCategoryData?.completedCount
                                                        : 0}
                                                    {/* {allCategoryData?.ongoingCount} */}
                                                </span>
                                            </div>
                                            <div className="card-icon" style={{ background: "#EAFFED" }}>
                                                <img
                                                    src={EyeIcon}
                                                    style={{ color: " #2CA63F", fontSize: "1.3rem" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </DashboardHeading>

                        <SearchFilterContainer>
                            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }} >
                                <Button
                                    type="button"
                                    style={{
                                        backgroundColor:
                                            tabSwitch == "1" ? "#5088FB" : "",
                                        color: tabSwitch == "1" ? "#ffffff" : "#201D23",
                                        fontSize: "14px",
                                        fontFamily: "Inter",
                                        fontWeight: tabSwitch == "1" ? "700" : "400"
                                    }}
                                    onClick={() => {
                                        handleCancel();
                                        handleServiceTypeChange("1");
                                        setPage(1);
                                    }}
                                    disabled={tabSwitch == "1"}
                                >
                                    Hosted Gigs{" "}
                                    {tabSwitch == "1"
                                        ? `(${isLoading ? "" : totalDocs})`
                                        : ""}
                                </Button>

                                <Button
                                    type="button"
                                    style={{
                                        backgroundColor:
                                            tabSwitch === "2" ? "#5088FB" : "",
                                        color: tabSwitch === "2" ? "#ffffff" : "#000000",
                                        fontSize: "14px",
                                        fontFamily: "Inter",
                                        fontWeight: tabSwitch == "2" ? "700" : "400"
                                    }}
                                    onClick={() => {
                                        handleCancel();
                                        handleServiceTypeChange("2");
                                        setPage(1);
                                    }}
                                    disabled={tabSwitch == "2"}
                                >
                                    Ongoing Gigs{" "}
                                    {tabSwitch == "2"
                                        ? `(${isLoading ? "" : totalDocs})`
                                        : ""}
                                </Button>

                                <Button
                                    type="button"
                                    style={{
                                        backgroundColor:
                                            tabSwitch === "3" ? "#5088FB" : "",
                                        color: tabSwitch === "3" ? "#ffffff" : "#000000",
                                        fontSize: "14px",
                                        fontFamily: "Inter",
                                        fontWeight: tabSwitch == "3" ? "700" : "400"

                                    }}
                                    onClick={() => {
                                        handleCancel();
                                        handleServiceTypeChange("3");
                                        setPage(1);
                                    }}
                                    disabled={tabSwitch == "3"}
                                >
                                    Completed Gigs{" "}
                                    {tabSwitch == "3"
                                        ? `(${isLoading ? "" : totalDocs})`
                                        : ""}
                                </Button>
                            </div>
                            <div
                                style={{ display: "flex", alignItems: "center", gap: "0.8rem" }}
                            >
                                <SearchBar
                                    style={{
                                        minWidth: "23rem",
                                        height: "38px",
                                        borderRadius: "20px",
                                        backgroundColor: "#F8F9FB",
                                        color: "#212121",
                                        fontStyle: "Italic",
                                        fontWeight: 300,
                                        fontSize: "15px",
                                        fontFamily: "Roboto",
                                    }}
                                    className={"heightfix"}
                                    onChange={(e) => {
                                        SearchAccountManagement(e);
                                    }}
                                    onCancelSearch={cancelSearch}
                                    placeholder="Gig Id, Gig name & Host Name"
                                    inputProps={{ maxLength: 30 }}
                                />

                                <div>
                                    <Button
                                        type="button"
                                        style={{ backgroundColor: "#FFFFFF", color: "#667085", border: "1px solid #E0E2E7", fontFamily: "Inter", fontWeight: "500", borderRadius: "8px" }}
                                        onClick={handleFilterClick}
                                    >
                                        <div >Apply Filter <HiOutlineBars3BottomLeft style={{ fontSize: "1.5rem", color: "#000000" }} /></div>
                                    </Button>
                                </div>
                            </div>

                        </SearchFilterContainer>

                        {/* Filter Popover */}
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                        >
                            <Box sx={{ p: 2, width: "300px" }}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: "0.8rem",
                                    }}
                                >
                                    <div className="text-filter">Advance Filter</div>
                                    <div className="clear-filter" onClick={handleCancel}>
                                        Reset All
                                    </div>
                                </div>



                                <div className="mb-3">
                                    <label className="lable_name_data_text">Start Date</label>
                                    <YearInput
                                        selected={startDate}
                                        // onChange={(date) => setStartDate(date || null)}
                                        onChange={handleStartDateChange}
                                        placeholderText="Select Date"
                                        maxDate={new Date()}
                                        className="selectInput"
                                    />
                                </div>

                                {tabSwitch == "3" && (
                                    <div className="mb-3">
                                        <label className="lable_name_data_text">Gig Completed Date</label>
                                        <YearInput
                                            selected={completedDate}
                                            // onChange={(date) => setStartDate(date || null)}
                                            onChange={handleCompletedDateChange}
                                            placeholderText="Select Completed Date"
                                            maxDate={new Date()}
                                            className="selectInput"
                                        />
                                    </div>
                                )}

                                {tabSwitch == "1" && (
                                    <div className="mb-3">
                                        <label className="lable_name_data_text">Gig Status</label>
                                        <Select
                                            isMulti
                                            value={selectedGigStatusOption}
                                            onChange={setSelectedGigStatusOption}
                                            options={GigStatusOptions}
                                            placeholder="Select Status"
                                            className="selectInput"
                                        />
                                    </div>
                                )}

                                {(tabSwitch == "2" || tabSwitch == "3") && (
                                    <div className="mb-3">
                                        <label className="lable_name_data_text">Gig Type</label>
                                        <Select
                                            isMulti
                                            value={selectedGigTypeOption}
                                            onChange={setSelectedGigTypeOption}
                                            options={GigTypeOptions}
                                            placeholder="Select Gig Type"
                                            className="selectInput"
                                        />
                                    </div>
                                )}


                                <div className="mb-3">
                                    <label className="lable_name_data_text">Zip Code</label>
                                    <Select
                                        isMulti
                                        value={selectedZipOption}
                                        onChange={setSelectedZipOption}
                                        options={zipCodeOptions}
                                        placeholder="Select Zip Code"
                                        className="selectInput"

                                    />
                                </div>

                                {tabSwitch == "1" && (
                                    <div className="mb-3">
                                        <label className="lable_name_data_text">User Type</label>
                                        <Select
                                            isMulti
                                            value={selectedTypeOption}
                                            onChange={setSelectedTypeOption}
                                            options={userTypeOptions}
                                            placeholder="Select User Type"
                                            className="selectInput"
                                        />
                                    </div>
                                )}

                                {(tabSwitch == "2" || tabSwitch == "3") && (
                                    <div className="mb-3">
                                        <label className="lable_name_data_text">Pay Type</label>
                                        <Select
                                            isMulti
                                            value={selectedPayOption}
                                            onChange={setSelectedPayOption}
                                            options={payTypeOptions}
                                            placeholder="Select Pay Type"
                                            className="selectInput"
                                        />
                                    </div>
                                )}

                                <Box
                                    sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}
                                >
                                    <Button onClick={handleClose} color="secondary">
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={handleApply}
                                        style={{
                                            background: "#5088FB",
                                            color: "#ffffff",
                                            padding: "0px 15px"
                                        }}
                                    >
                                        Apply
                                    </Button>
                                </Box>
                            </Box>
                        </Popover>




                        <TableContainer className={classes.tableMainContainer}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.tableHeadingRow}>

                                        <TableCell className={classes.tableHeadingCell}>
                                            S.No
                                        </TableCell>
                                        {tabSwitch == "1" && (
                                            <>
                                                {!(!canBlockUnblock && adminData?.userType === "subAdmin") && (
                                                    <TableCell className={classes.tableHeadingCell}>
                                                        Action
                                                    </TableCell>
                                                )}
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Status
                                                </TableCell>
                                            </>
                                        )}
                                        <TableCell className={classes.tableHeadingCell}>
                                            Gig ID
                                        </TableCell>
                                        {(tabSwitch == "3") && (
                                            <TableCell className={classes.tableHeadingCell}>
                                                Download invoice
                                            </TableCell>
                                        )}
                                        {(tabSwitch == "2" || tabSwitch == "3") && (
                                            <>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Payment Status Received
                                                </TableCell>
                                            </>
                                        )}
                                        {tabSwitch == "3" && (
                                            <>

                                                <TableCell className={classes.tableHeadingCell}>
                                                    Payment Status Sent
                                                </TableCell>
                                            </>
                                        )}
                                        <TableCell className={classes.tableHeadingCell} >
                                            <div style={{ textAlign: "left", marginLeft: "1.2rem" }}>
                                                Gig Title
                                            </div>
                                        </TableCell>
                                        {tabSwitch == "1" && (
                                            <>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Gig Posted Date
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell} >
                                                    <div style={{ textAlign: "left", marginLeft: "1rem" }}>
                                                        Hosted By{" "}
                                                        <img
                                                            src={vector}
                                                            style={{
                                                                cursor: "pointer",
                                                                transition: "transform 0.3s ease",
                                                                transform: `rotate(${rotations.sortByHostName}deg)`,
                                                            }}
                                                            onClick={() => toggleSort("sortByHostName")}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    User Type{" "}
                                                    <img
                                                        src={vector}
                                                        style={{
                                                            cursor: "pointer",
                                                            transition: "transform 0.3s ease",
                                                            transform: `rotate(${rotations.sortByUserType}deg)`,
                                                        }}
                                                        onClick={() => toggleSort("sortByUserType")}
                                                    />
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Proposal Received
                                                </TableCell>
                                            </>
                                        )}
                                        {(tabSwitch == "2" || tabSwitch == "3") && (
                                            <>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    <div style={{ textAlign: "left", marginLeft: "1rem" }}>
                                                        Hosted Name{" "}
                                                        <img
                                                            src={vector}
                                                            style={{
                                                                cursor: "pointer",
                                                                transition: "transform 0.3s ease",
                                                                transform: `rotate(${rotations.sortByOngoingHostName}deg)`,
                                                            }}
                                                            onClick={() => toggleSort("sortByOngoingHostName")}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell} >
                                                    <div style={{ textAlign: "left", marginLeft: "1rem" }}>
                                                        Worker Name
                                                    </div>
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell} >
                                                    Pay Type
                                                </TableCell>
                                            </>
                                        )}

                                        <TableCell className={classes.tableHeadingCell}>
                                            Start Date
                                        </TableCell>

                                        {(tabSwitch == "1" || tabSwitch == "3") && (
                                            <TableCell className={classes.tableHeadingCell}>
                                                End Date
                                            </TableCell>
                                        )}

                                        {(tabSwitch == "2" || tabSwitch == "3") && (
                                            <>
                                                <TableCell className={classes.tableHeadingCell} style={{ width: "6rem", }}>
                                                    Gig Type
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Gig Hours
                                                </TableCell>
                                            </>
                                        )}

                                        {tabSwitch == "3" && (
                                            <>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Completed On
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Host's Rating
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Worker's Rating
                                                </TableCell>
                                            </>
                                        )}

                                        <TableCell className={classes.tableHeadingCell} >
                                            Amount ($)
                                        </TableCell>

                                        {tabSwitch == "3" && (
                                            <>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Paid By Host
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell} >
                                                    Amount Received
                                                    <br />
                                                    (to Worker)
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Amount Received
                                                    <br />
                                                    (to Admin)
                                                </TableCell>

                                            </>
                                        )}

                                        <TableCell className={classes.tableHeadingCell}>
                                            Zip Code
                                        </TableCell>
                                        {(tabSwitch == "2" || tabSwitch == "3") && (
                                            <>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                        Gig Description
                                                    </div>
                                                </TableCell>
                                            </>
                                        )}
                                    </TableRow>
                                </TableHead>
                                {isLoading && tableData && tableData.length > 0 ? (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={13} align="center" style={{ border: "none" }}>
                                                <Loading />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                ) : tableData && tableData.length > 0 ? (
                                    <>
                                        <TableBody>
                                            {tableData.map((user, index) => (
                                                <TableRow
                                                    className={classes.tableBodyRow}
                                                    key={user._id}
                                                >
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                                                    </TableCell>

                                                    {tabSwitch == "1" && (
                                                        <>
                                                            {/* {!(!canBlockUnblock && adminData?.userType === "subAdmin") && (
                                                                <TableCell className={classes.textMiddle}>
                                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                        <BlockToggle
                                                                            checked={!user.isBlocked}
                                                                            onChange={() => blockUnblock(user._id, !user.isBlocked)}
                                                                        />
                                                                    </div>
                                                                </TableCell>
                                                            )} */}
                                                           
                                                            {!(!canBlockUnblock && adminData?.userType === "subAdmin") && (
                                                                <TableCell className={classes.textMiddle}>
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            pointerEvents:
                                                                                ["0", "1"].includes(get(user, "status")) || get(user, "isBlocked") === true
                                                                                    ? "auto"
                                                                                    : "none",
                                                                            opacity:
                                                                                ["0", "1"].includes(get(user, "status")) || get(user, "isBlocked") === true
                                                                                    ? 1
                                                                                    : 0.5
                                                                        }}
                                                                    >
                                                                        <BlockToggle
                                                                            checked={!user.isBlocked}
                                                                            onChange={() => blockUnblock(user._id, !user.isBlocked)}
                                                                        />
                                                                    </div>
                                                                </TableCell>
                                                            )}
                                                            <TableCell className={classes.textMiddle}>

                                                                {get(user, "isBlocked") === true ? (
                                                                    <div
                                                                        style={{
                                                                            padding: "3px 29px",
                                                                            borderRadius: "31px",
                                                                            color: "#FB5050",
                                                                            backgroundColor: "#FFEBEB",
                                                                        }}
                                                                    >
                                                                        Blocked
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        style={{
                                                                            padding: "3px 29px",
                                                                            borderRadius: "31px",
                                                                            color:
                                                                                get(user, "status") === "1"
                                                                                    ? "#5088FB"
                                                                                    : get(user, "status") === "0"
                                                                                        ? "#21272A"
                                                                                        : get(user, "status") === "3"
                                                                                            ? "#FB5050"
                                                                                            : get(user, "status") === "4"
                                                                                                ? "#2CA63F"
                                                                                                : get(user, "status") === "5"
                                                                                                    ? "#FF6200"
                                                                                                    : get(user, "status") === "6"
                                                                                                        ? "#44B155"
                                                                                                        : "inherit",
                                                                            backgroundColor:
                                                                                get(user, "status") === "1"
                                                                                    ? "#EBF2FF"
                                                                                    : get(user, "status") === "0"
                                                                                        ? "#D6D6D6"
                                                                                        : get(user, "status") === "3"
                                                                                            ? "#FFEBEB"
                                                                                            : get(user, "status") === "4"
                                                                                                ? "#EAFFED"
                                                                                                : get(user, "status") === "5"
                                                                                                    ? "#FFF5E9"
                                                                                                    : get(user, "status") === "6"
                                                                                                        ? "#EAFFED"
                                                                                                        : "inherit",
                                                                        }}
                                                                    >
                                                                        {get(user, "status") === "1"
                                                                            ? "Active"
                                                                            : get(user, "status") === "0"
                                                                                ? "Inactive"
                                                                                : get(user, "status") === "3"
                                                                                    ? "Expired"
                                                                                    : get(user, "status") === "4"
                                                                                        ? "Hired"
                                                                                        : get(user, "status") === "5"
                                                                                            ? "Ongoing"
                                                                                            : get(user, "status") === "6"
                                                                                                ? "Completed"
                                                                                                : "---"}
                                                                    </div>
                                                                )}


                                                            </TableCell>
                                                        </>)}

                                                    <TableCell className={classes.textMiddle}>
                                                        <div>
                                                            {get(user, "gigDetailId", "---")}
                                                        </div>
                                                    </TableCell>

                                                    {(tabSwitch == "3") && (
                                                        <TableCell className={classes.textMiddle}>
                                                            <div style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: "5px",
                                                                border: "1px solid #C3D3E2",
                                                                borderRadius: "2px",
                                                                height: "2rem",
                                                                // width: "7rem",
                                                                fontSize: "14px",
                                                                fontFamily: "Roboto",
                                                                fontWeight: "500",
                                                                color: "#212121",
                                                                cursor: "pointer",
                                                                padding: "0px 10px"
                                                            }}
                                                                onClick={() => invoiceDownload(user?._id)}
                                                            >
                                                                <PiExportBold style={{ fontSize: "14px" }} />
                                                                <div>Download</div>
                                                            </div>
                                                        </TableCell>
                                                    )}

                                                    {tabSwitch == "2" && (
                                                        <TableCell className={classes.textMiddle}>


                                                            {(() => {
                                                                let statusText = "N/A";

                                                                if (
                                                                    (user?.gigTransactionDetails?.length === 1 &&
                                                                        user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "available" &&
                                                                        user?.gigPayType === "hourly" && user?.payoutStatus === "processed")
                                                                ) {
                                                                    statusText = "Partial Received";
                                                                } else if (
                                                                    (user?.gigTransactionDetails?.length === 1 &&
                                                                        user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "available" &&
                                                                        user?.gigPayType === "hourly" && user?.payoutStatus === "completed")
                                                                ) {
                                                                    statusText = "Fully Received";
                                                                }
                                                                else if (
                                                                    (user?.gigTransactionDetails?.length === 2 &&
                                                                        user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "available" &&
                                                                        user?.gigTransactionDetails?.[1]?.availableBalanceStatus === "available") ||

                                                                    (user?.gigTransactionDetails?.length === 1 &&
                                                                        user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "available")
                                                                ) {
                                                                    statusText = "Fully Received";
                                                                } else if (
                                                                    (user?.gigTransactionDetails?.length === 2 &&
                                                                        user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "pending" &&
                                                                        user?.gigTransactionDetails?.[1]?.availableBalanceStatus === "pending") ||
                                                                    (user?.gigTransactionDetails?.length === 1 &&
                                                                        user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "pending")
                                                                ) {
                                                                    statusText = "In Process";
                                                                } else if (
                                                                    user?.gigTransactionDetails?.length === 2 &&
                                                                    ((user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "pending" &&
                                                                        user?.gigTransactionDetails?.[1]?.availableBalanceStatus === "available") ||
                                                                        (user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "available" &&
                                                                            user?.gigTransactionDetails?.[1]?.availableBalanceStatus === "pending"))
                                                                ) {
                                                                    statusText = "Partial Received";
                                                                }

                                                                // Styling map based on statusText
                                                                const styleMap = {
                                                                    "Fully Received": { color: "#44B155", background: "#EAFFED" },
                                                                    "In Process": { color: "#FDA517", background: "#FFF3E3" },
                                                                    "Partial Received": { color: "#5088FB", background: "#F3F7FF" },
                                                                    "N/A": { color: "#999999", background: "#F2F2F2" }
                                                                };

                                                                return (
                                                                    <div
                                                                        style={{
                                                                            // padding: "3px 18px",
                                                                            height: "1.5rem",
                                                                            width: "9rem",
                                                                            alignContent: "center",
                                                                            borderRadius: "31px",
                                                                            whiteSpace: "nowrap",
                                                                            display: "inline-block",
                                                                            fontSize: "13px",
                                                                            ...styleMap[statusText]
                                                                        }}
                                                                    >
                                                                        <div>
                                                                            <span style={{ display: "flex", gap: "1rem", alignItems: "center", justifyContent: "center" }}>
                                                                                {statusText}
                                                                                {(statusText === "Fully Received" || statusText === "Partial Received") && (
                                                                                    <TiInfoLarge
                                                                                        style={{
                                                                                            backgroundColor: statusText === "Fully Received" ? "#44B155" : "#5088FB",
                                                                                            color: "#FFFFFF",
                                                                                            fontSize: "0.8rem",
                                                                                            cursor: "pointer",
                                                                                            borderRadius: "1rem",
                                                                                        }}
                                                                                        onClick={(e) => {
                                                                                            setStatusHistryData(user || []);
                                                                                            setUserInfo(user);
                                                                                            handleClick(e)

                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </span>


                                                                        </div>
                                                                    </div>
                                                                );
                                                            })()}
                                                        </TableCell>
                                                    )}

                                                    {tabSwitch == "3" && (
                                                        <TableCell className={classes.textMiddle}>


                                                            {(() => {
                                                                let statusText = "N/A";

                                                                if (
                                                                    (user?.gigTransactionDetails?.length === 2 &&
                                                                        user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "available" &&
                                                                        user?.gigTransactionDetails?.[1]?.availableBalanceStatus === "available") ||

                                                                    (user?.gigTransactionDetails?.length === 1 &&
                                                                        user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "available")
                                                                ) {
                                                                    statusText = "Fully Received";
                                                                } else if (
                                                                    (user?.gigTransactionDetails?.length === 2 &&
                                                                        user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "pending" &&
                                                                        user?.gigTransactionDetails?.[1]?.availableBalanceStatus === "pending") ||
                                                                    (user?.gigTransactionDetails?.length === 1 &&
                                                                        user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "pending")
                                                                ) {
                                                                    statusText = "In Process";
                                                                } else if (
                                                                    user?.gigTransactionDetails?.length === 2 &&
                                                                    ((user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "pending" &&
                                                                        user?.gigTransactionDetails?.[1]?.availableBalanceStatus === "available") ||
                                                                        (user?.gigTransactionDetails?.[0]?.availableBalanceStatus === "available" &&
                                                                            user?.gigTransactionDetails?.[1]?.availableBalanceStatus === "pending"))
                                                                ) {
                                                                    statusText = "Partial Received";
                                                                }

                                                                // Styling map based on statusText
                                                                const styleMap = {
                                                                    "Fully Received": { color: "#44B155", background: "#EAFFED" },
                                                                    "In Process": { color: "#FF4141", background: "#FFF0F0" },
                                                                    "Partial Received": { color: "#FDA517", background: "#FFF3E3" },
                                                                    "N/A": { color: "#999999", background: "#F2F2F2" }
                                                                };

                                                                return (
                                                                    <div
                                                                        style={{
                                                                            // padding: "3px 18px",
                                                                            width: "8rem",
                                                                            height: "1.5rem",
                                                                            alignContent: "center",
                                                                            borderRadius: "31px",
                                                                            whiteSpace: "nowrap",
                                                                            display: "inline-block",
                                                                            fontSize: "13px",
                                                                            ...styleMap[statusText]
                                                                        }}
                                                                    >
                                                                        <div>
                                                                            <span style={{ display: "flex", gap: "1rem", alignItems: "center", justifyContent: "center" }}>
                                                                                {statusText}
                                                                                {(statusText === "Fully Received" || statusText === "Partial Received") && (
                                                                                    <TiInfoLarge
                                                                                        style={{
                                                                                            backgroundColor: statusText === "Fully Received" ? "#44B155" : "#5088FB",
                                                                                            color: "#FFFFFF",
                                                                                            fontSize: "0.8rem",
                                                                                            cursor: "pointer",
                                                                                            borderRadius: "1rem",
                                                                                        }}
                                                                                        onClick={(e) => {
                                                                                            setStatusHistryData(user || []);
                                                                                            setUserInfo(user);
                                                                                            handleClick(e)

                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </span>


                                                                        </div>
                                                                    </div>
                                                                );
                                                            })()}
                                                        </TableCell>
                                                    )}

                                                    {tabSwitch == "3" && (
                                                        <>

                                                            <TableCell className={classes.textMiddle} >
                                                                <div
                                                                    style={{
                                                                        // padding: "3px 18px",
                                                                        height: "1.5rem",
                                                                        width: "8rem",
                                                                        alignContent: "center",
                                                                        borderRadius: "31px",
                                                                        color: get(user, "payoutStatus") === "completed" ? "#44B155" : "#FF4141",
                                                                        background: get(user, "payoutStatus") === "completed" ? "#EAFFED" : "#FFF0F0",
                                                                        whiteSpace: "nowrap",
                                                                        display: "inline-block",
                                                                        fontSize: "13px"
                                                                    }}>
                                                                    {get(user, "payoutStatus") === "completed" ? "Sent" : "In Processing"}
                                                                </div>
                                                            </TableCell>
                                                        </>
                                                    )}

                                                    <TableCell className={classes.textMiddle}>
                                                        <div
                                                            style={{
                                                                color: "#4D59FF",
                                                                textDecoration: "underline",
                                                                cursor: "pointer",
                                                                width: "8rem",
                                                                textAlign: "left",
                                                                marginLeft: "1rem",
                                                                overflow: "hidden",
                                                                whiteSpace: "nowrap",
                                                                textOverflow: "ellipsis",

                                                            }}
                                                            title={get(user, "gigTitle", "---")}
                                                            onClick={() => navigate(`/gigOverview/${user._id}`,
                                                                { state: { from: "gigsManagement" } })}
                                                        >
                                                            {get(user, "gigTitle", "---")}
                                                        </div>
                                                    </TableCell>

                                                    {tabSwitch == "1" && (
                                                        <>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div>
                                                                    {extractOnlyDate(get(user, "createdAt", "---"))}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div
                                                                    style={{
                                                                        color: "#4D59FF",
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer",
                                                                        width: "6rem",
                                                                        textAlign: "left",
                                                                        marginLeft: "1rem"
                                                                    }}
                                                                    onClick={
                                                                        !(isSubAdmin && hasNoUserManagementPermissions)
                                                                            ? () => navigate(`/userDetails/${user.userId}`, {
                                                                                state: { from: "gigsManagement" },
                                                                            })
                                                                            : undefined
                                                                    }
                                                                >
                                                                    {get(user, "userData.fullName", "---")}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div style={{ textTransform: "capitalize" }}>
                                                                    {get(user, "gigUserType", "---")}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div>
                                                                    {get(user, "proposalCount", "---")}
                                                                </div>
                                                            </TableCell>
                                                        </>
                                                    )}

                                                    {(tabSwitch == "2" || tabSwitch == "3") && (
                                                        <>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div
                                                                    style={{
                                                                        color: "#4D59FF",
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer",
                                                                        textAlign: "left",
                                                                        marginLeft: "1rem"
                                                                    }}

                                                                    onClick={
                                                                        !(isSubAdmin && hasNoUserManagementPermissions)
                                                                            ? () => navigate(`/userDetails/${user.userId}`, {
                                                                                state: { from: "gigsManagement" },
                                                                            })
                                                                            : undefined
                                                                    }

                                                                >
                                                                    {get(user, "hostDetails.firstName") || get(user, "hostDetails.lastName")
                                                                        ? `${get(user, "hostDetails.firstName", "")} ${get(user, "hostDetails.lastName", "")}`.trim()
                                                                        : "N/A"}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div
                                                                    style={{ color: "#29A4C0", textDecoration: "underline", cursor: "pointer", textAlign: "left", marginLeft: "1rem" }}

                                                                    onClick={
                                                                        !(isSubAdmin && hasNoUserManagementPermissions)
                                                                            ? () => navigate(`/userDetails/${user.userId}`, {
                                                                                state: { from: "gigsManagement" },
                                                                            })
                                                                            : undefined
                                                                    }

                                                                >
                                                                    {get(user, "workertDetails.firstName") || get(user, "workertDetails.lastName")
                                                                        ? `${get(user, "workertDetails.firstName", "")} ${get(user, "workertDetails.lastName", "")}`.trim()
                                                                        : "N/A"}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div style={{ textTransform: "capitalize" }}>
                                                                    {get(user, "gigPayType", "---")}
                                                                </div>
                                                            </TableCell>
                                                        </>
                                                    )}


                                                    <TableCell className={classes.textMiddle}>
                                                        <div >
                                                            {extractOnlyDate(get(user, "startDate", "---"))}
                                                        </div>
                                                    </TableCell>

                                                    {(tabSwitch == "1" || tabSwitch == "3") && (
                                                        <TableCell className={classes.textMiddle}>
                                                            <div>
                                                                {extractOnlyDate(get(user, "endDate", "---"))}
                                                            </div>
                                                        </TableCell>
                                                    )}

                                                    {(tabSwitch == "2" || tabSwitch == "3") && (
                                                        <>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div style={{ textTransform: "capitalize" }}>
                                                                    {user?.gigType || "N/A"}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div >
                                                                    {user?.hourlyAmount || "N/A"}
                                                                </div>
                                                            </TableCell>
                                                        </>
                                                    )}

                                                    {tabSwitch == "3" && (
                                                        <>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div >
                                                                    {extractOnlyDate(get(user, "payoutTransactionDetails.createdAt", "---"))}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>

                                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}>
                                                                    <div style={{
                                                                        width: "41px",
                                                                        height: "21px",
                                                                        background: "#FFF4E7",
                                                                        border: "0.75px solid #0000001F",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        gap: "2px",
                                                                        padding: "10px"
                                                                    }}>
                                                                        {(() => {
                                                                            const rating = get(user, "hostFeedbackDetails.averageRating");
                                                                            return rating !== undefined && rating !== null
                                                                                ? Number(rating).toFixed(1).replace(/\.0$/, "")
                                                                                : "0";
                                                                        })()}
                                                                        <img src={Star} />
                                                                    </div> <GrCircleInformation style={{ cursor: "pointer", fontSize: "1.2rem" }} onClick={() => {
                                                                        setHostSelectedUser(user); // set clicked user
                                                                        setHostDescription(true);
                                                                    }} />
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>

                                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}>
                                                                    <div style={{
                                                                        width: "41px",
                                                                        height: "21px",
                                                                        background: "#FFF4E7",
                                                                        border: "0.75px solid #0000001F",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        gap: "2px",
                                                                        padding: "10px"
                                                                    }}>
                                                                        {(() => {
                                                                            const rating = get(user, "workerFeedbackDetails.averageRating");
                                                                            return rating !== undefined && rating !== null
                                                                                ? Number(rating).toFixed(1).replace(/\.0$/, "")
                                                                                : "0";
                                                                        })()}
                                                                        <img src={Star} />
                                                                    </div> <GrCircleInformation style={{ cursor: "pointer", fontSize: "1.2rem" }} onClick={() => {
                                                                        setSelectedUser(user); // set clicked user
                                                                        setDescription(true);
                                                                    }} />
                                                                </div>
                                                            </TableCell>
                                                        </>
                                                    )}

                                                    <TableCell className={classes.textMiddle}>

                                                        <div style={{ width: "6rem" }}>
                                                            {get(user, "contractGigAmount") ? (
                                                                get(user, "contractGigAmount")
                                                            ) : get(user, "hourlyAmount") ? (
                                                                `${get(user, "hourlyAmount")} Per Hour`
                                                            ) : (
                                                                "N/A"
                                                            )}
                                                        </div>
                                                    </TableCell>

                                                    {tabSwitch == "3" && (
                                                        <>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div >
                                                                    {user?.paidByHost
                                                                        ? Number(user.paidByHost).toFixed(1).replace(/\.0$/, "")
                                                                        : "0"}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div >
                                                                    {user?.paidToWorker
                                                                        ? Number(user.paidToWorker).toFixed(1).replace(/\.0$/, "")
                                                                        : "N/A"}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>

                                                                <div >
                                                                    {user?.paidToAdmin
                                                                        ? Number(user.paidToAdmin).toFixed(1).replace(/\.0$/, "")
                                                                        : "N/A"}
                                                                </div>
                                                            </TableCell>
                                                        </>
                                                    )}

                                                    <TableCell className={classes.textMiddle}>
                                                        <div >
                                                            {user?.zipCode || "N/A"}
                                                        </div>
                                                    </TableCell>

                                                    {(tabSwitch == "2" || tabSwitch == "3") && (
                                                        <TableCell className={classes.textMiddle}>
                                                            <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                                <ReactReadMoreReadLess
                                                                    charLimit={10}
                                                                    readMoreText={"Read more"}
                                                                    readLessText={"Read less"}
                                                                    readMoreStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                                                    readLessStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                                                >
                                                                    {user?.gigDescription || "N/A"}
                                                                </ReactReadMoreReadLess>

                                                            </div>
                                                        </TableCell>
                                                    )}

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </>
                                ) : (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell
                                                    colSpan={13}
                                                    align="center"
                                                    style={{ padding: "2rem", border: "none" }}
                                                >
                                                    <DashHeading
                                                        style={{ textAlign: "center", padding: "2rem" }}
                                                    >
                                                        <NoResults />
                                                    </DashHeading>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {(tableData && tableData.length > 0) && (
                            <>
                                <Stack spacing={2} className={classes.paginationContainer}>
                                    <Pagination
                                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                                        page={page}
                                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                                        renderItem={(item) => (
                                            <PaginationItem
                                                slots={{
                                                    previous: HiMiniArrowLeft,
                                                    next: HiMiniArrowRight,
                                                }}
                                                {...item}
                                            />
                                        )}
                                    />
                                </Stack>
                            </>
                        )}
                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer >


            {/* Filter Popover */}
            <Popover
                id={ids}
                open={openData}
                anchorEl={anchorElData}
                onClose={handleCloseData}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Box sx={{ p: 2.3, width: "300px" }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "0.8rem",
                        }}
                    >


                        <div className="text-filter-cross">
                            {statusHistryData?.gigTransactionDetails?.length === 2 &&
                                (
                                    (statusHistryData?.gigTransactionDetails?.[0]?.availableBalanceStatus === "pending" &&
                                        statusHistryData?.gigTransactionDetails?.[1]?.availableBalanceStatus === "available") ||
                                    (statusHistryData?.gigTransactionDetails?.[0]?.availableBalanceStatus === "available" &&
                                        statusHistryData?.gigTransactionDetails?.[1]?.availableBalanceStatus === "pending")
                                ) ? (
                                <span>Partial Received Detail</span>
                            ) : (
                                <span>Fully Received Detail</span>
                            )}
                        </div>
                        <div className="clear-filter-Cross" onClick={handleCloseData}>
                            <RxCross2 />
                        </div>


                    </div>

                    <div style={{ marginTop: "0.8rem" }}>

                        <div className="stepper-container">
                            {(statusHistryData?.gigTransactionDetails?.length > 0)
                                ? statusHistryData?.gigTransactionDetails.map((data, index) => (
                                    <React.Fragment key={index}>
                                        <div className="stepper-item">
                                            <div className="stepper-line" />
                                            <div className="stepper-dot" />
                                            <div className="stepper-content">
                                                <div className="stepper-status">
                                                    Payment transferred by {statusHistryData?.userData?.fullName}
                                                </div>
                                                <div className="stepper-date">
                                                    {/* {get(data, "availableOn")
                                                        ? extractDate(new Date(get(data, "availableOn") * 1000).toISOString())
                                                        : "N/A"} */}

                                                    {statusHistryData?.transactionDetails?.createdAt
                                                        ? extractDate(statusHistryData?.transactionDetails?.createdAt)
                                                        : "N/A"}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="stepper-item">
                                            <div className="stepper-line" />
                                            <div className="stepper-dot" />
                                            <div className="stepper-content">
                                                <div className="stepper-status">Added to Stripe Wallet On</div>
                                                <div className="stepper-date">
                                                    {get(data, "availableOn")
                                                        ? extractDate(new Date(get(data, "availableOn") * 1000).toISOString())
                                                        : "N/A"}

                                                    {/* {statusHistryData?.transactionDetails?.createdAt
                                                        ? extractDate(statusHistryData?.transactionDetails?.createdAt)
                                                        : "N/A"} */}
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))
                                : (
                                    <div className="no-data">No data available</div>
                                )}
                        </div>
                    </div>



                </Box>
            </Popover>


            {/* Modal for Description */}
            < Modal
                maxWidth="lg"
                width="420px"
                RoundedCorners={true}
                isOpen={description}
                onClose={() => {
                    setDescription(false);
                }}
                backgroundModal={false}
                backgroundModalContent={false}

                title={
                    <div >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                            <div>Worker's Rating</div>
                            <div><RxCross2 style={{ cursor: "pointer" }} onClick={() => setDescription(false)} /></div>
                        </div>

                        <div style={{ marginTop: "1rem" }}>
                            <div
                                style={{
                                    display: "flex",
                                    gap: "1.5rem",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    justifyContent: "space-between"
                                }}
                            >
                                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                                    <div className="Model_Data_text">Clarity of work</div>
                                    <div className="Model_Data_text">Timely communication</div>
                                    <div className="Model_Data_text">Work environment</div>
                                    <div className="Model_Data_text">Willing to work again </div>

                                </div>
                                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                                    <div className="Model_Data_text">
                                        <Stars
                                            count={5}
                                            value={parseFloat(selectedUser?.workerFeedbackDetails?.clarityOfWork) || 0} // fallback to 0 if undefined
                                            size={23}
                                            edit={false}
                                            half={true}
                                            color2="#FFAE46" // Yellow/Orange color
                                        />
                                    </div>
                                    <div className="Model_Data_text">
                                        <Stars
                                            count={5}
                                            value={parseFloat(selectedUser?.workerFeedbackDetails?.timelyCommunication) || 0} // fallback to 0 if undefined
                                            size={23}
                                            edit={false}
                                            half={true}
                                            color2="#FFAE46" // Yellow/Orange color
                                        />
                                    </div>
                                    <div className="Model_Data_text">
                                        <Stars
                                            count={5}
                                            value={parseFloat(selectedUser?.workerFeedbackDetails?.workEnvironment) || 0} // fallback to 0 if undefined
                                            size={23}
                                            edit={false}
                                            half={true}
                                            color2="#FFAE46" // Yellow/Orange color
                                        />
                                    </div>
                                    <div className="Model_Data_text">
                                        <Stars
                                            count={5}
                                            value={parseFloat(selectedUser?.workerFeedbackDetails?.willingToWorkAgain) || 0} // fallback to 0 if undefined
                                            size={23}
                                            edit={false}
                                            half={true}
                                            color2="#FFAE46" // Yellow/Orange color
                                        />
                                    </div>

                                </div>
                            </div>
                            <div style={{ marginTop: "1.5rem" }}>
                                <div className="gigDescriptionHeading">Feedback:</div>
                                <div className="data_description_modal">
                                    {selectedUser?.workerFeedbackDetails?.feedbackDescription || "No Feedback provided"}
                                </div>
                            </div>
                        </div>

                    </div >
                }
                content={
                    <>

                    </>
                }
            />


            < Modal
                maxWidth="lg"
                width="420px"
                RoundedCorners={true}
                isOpen={hostDescription}
                onClose={() => {
                    setHostDescription(false);
                }}
                backgroundModal={false}
                backgroundModalContent={false}

                title={
                    <div >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                            <div>Worker's Rating</div>
                            <div><RxCross2 style={{ cursor: "pointer" }} onClick={() => setHostDescription(false)} /></div>
                        </div>

                        <div style={{ marginTop: "1rem" }}>
                            <div
                                style={{
                                    display: "flex",
                                    gap: "1.5rem",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    justifyContent: "space-between"
                                }}
                            >
                                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                                    <div className="Model_Data_text">Punctuality</div>
                                    <div className="Model_Data_text">Professionalism</div>
                                    <div className="Model_Data_text">Work Quality</div>
                                    <div className="Model_Data_text">Dedication & Effort </div>
                                    <div className="Model_Data_text">Skill & Competence</div>

                                </div>
                                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                                    <div className="Model_Data_text">
                                        <Stars
                                            count={5}
                                            value={parseFloat(hostSelectedUser?.hostFeedbackDetails?.punctuality) || 0} // fallback to 0 if undefined
                                            size={23}
                                            edit={false}
                                            half={true}
                                            color2="#FFAE46" // Yellow/Orange color
                                        />
                                    </div>
                                    <div className="Model_Data_text">
                                        <Stars
                                            count={5}
                                            value={parseFloat(hostSelectedUser?.hostFeedbackDetails?.professionalism) || 0} // fallback to 0 if undefined
                                            size={23}
                                            edit={false}
                                            half={true}
                                            color2="#FFAE46" // Yellow/Orange color
                                        />
                                    </div>
                                    <div className="Model_Data_text">
                                        <Stars
                                            count={5}
                                            value={parseFloat(hostSelectedUser?.hostFeedbackDetails?.workQuality) || 0} // fallback to 0 if undefined
                                            size={23}
                                            edit={false}
                                            half={true}
                                            color2="#FFAE46" // Yellow/Orange color
                                        />
                                    </div>
                                    <div className="Model_Data_text">
                                        <Stars
                                            count={5}
                                            value={parseFloat(hostSelectedUser?.hostFeedbackDetails?.dedicationAndEffort) || 0} // fallback to 0 if undefined
                                            size={23}
                                            edit={false}
                                            half={true}
                                            color2="#FFAE46" // Yellow/Orange color
                                        />
                                    </div>
                                    <div className="Model_Data_text">
                                        <Stars
                                            count={5}
                                            value={parseFloat(hostSelectedUser?.hostFeedbackDetails?.skillAndCompetence) || 0} // fallback to 0 if undefined
                                            size={23}
                                            edit={false}
                                            half={true}
                                            color2="#FFAE46" // Yellow/Orange color
                                        />
                                    </div>

                                </div>
                            </div>
                            <div style={{ marginTop: "1.5rem" }}>
                                <div className="gigDescriptionHeading">Feedback:</div>
                                <div className="data_description_modal">
                                    {hostSelectedUser?.hostFeedbackDetails?.feedbackDescription || "No Feedback provided"}
                                </div>
                            </div>
                        </div>

                    </div >
                }
                content={
                    <>

                    </>
                }
            />

            {isLoading && <Overlay />
            }
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GigsManagement);

